import { useContext } from 'react';
import {
  ApiFilterOperation,
  DetailContext,
  DetailHandle,
  Params,
  abortableFetch,
} from '@eas/common-web';
import { Dispatch } from '@models';
import { DispatchState, EvidenceApiUrl } from '@enums';

export const dispatchDocumentsApiCall = (
  params?: Params,
  selected?: string[],
  test = true
) => {
  return abortableFetch(
    `${EvidenceApiUrl.DOCUMENTS_DISPATCHES}/dispatch?test=${test}`,
    {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        ...params,
        filters: [
          ...(params?.filters ?? []),
          ...(selected?.length
            ? [
                {
                  operation: ApiFilterOperation.IDS,
                  ids: selected,
                },
              ]
            : []),
        ],
      }),
    }
  );
};

export function useDispatchSingleDocumentDialog() {
  const { source } = useContext<DetailHandle<Dispatch>>(DetailContext);

  const showButton = source?.data?.state === DispatchState.SENT; // TODO rework

  const callApi = (id: string) => {
    return abortableFetch(
      `${EvidenceApiUrl.DOCUMENTS_DISPATCHES}/${id}/dispatch`,
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
        }),
      }
    );
  };

  return { callApi, showButton };
}
